import { store } from '@/store/store'
import axios from 'axios'
import config from '../config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}nestle`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const nestleApi = {
  getAllBundles: (request) => {
    // {
    //     "search": "name bundle",
    //     "startDate": "YYYY-MM-DD", // optional
    //     "endDate": "YYYY-MM-DD", // optional
    //     "sortBy": "Promotion date", // optional
    //     "limit": 10,
    //     "offset": 0
    // }
    const { data } = request
    const { pageid, ...rest } = data
    return instance().post(`/${pageid}/product-bundle/all-bundles`, rest)
  },
  getAvailableProducts: (request) => {
    // {
    //     "categoryid": 0, // optional
    //     "search": "product name or sku", // optional
    //     "limit": 10,
    //     "offset": 0
    // }
    const { data } = request
    const { pageid, ...rest } = data
    return instance().post(`/${pageid}/product-bundle/available-products`, rest)
  },
  postProductBundle: (request) => {
    const { data } = request
    const { pageid, ...rest } = data
    // {
    //     "name": "name of bundle",
    //     "quantity_condition": 1,
    //     "discount": 20,
    //     "effective_date": "YYYY-MM-DD HH:MM", // optional
    //     "end_date": "YYYY-MM-DD HH:MM", // optional
    //     "limits": 10, // optional จำนวนครั้งที่สามารถใช้ได้
    //     "product_ids": [1, 2, 3] // Array product id
    // }
    return instance().post(`/${pageid}/product-bundle/create-bundle`, rest)
  },
  putProductBundle: (request) => {
    const { data } = request
    const { pageid, id, ...rest } = data
    // *** BODY HAVE MUST AT LEAST ONE PARAMETER FOR UPDATE
    // {
    //     "name": "nome of bundle", // optional
    //     "quantity_condition": 1, // optional
    //     "discount": 10, // optional
    //     "effective_date": "YYYY-MM-DD HH:mm", // optional
    //     "end_date": "YYYY-MM-DD HH:mm", // optional
    //     "limits": null, // optional
    //     "product_ids": [2, 3, 4] // optional
    // }
    return instance().put(`/${pageid}/product-bundle/upadte-bundle/${id}`, rest)
  },
  deleteProductBundle: (request) => {
    const { data } = request
    const { pageid, id } = data
    return instance().delete(`/${pageid}/product-bundle/delete-bundle/${id}`)
  },
  putProductBundleStatus: (request) => {
    const { data } = request
    const { pageid, id, ...rest } = data
    // {
    //     "status": true
    // }
    return instance().put(`/${pageid}/product-bundle/update-bundle-status/${id}`, rest)
  }
}

export default nestleApi



// WEBPACK FOOTER //
// ./src/api/nestle.js